
import { Component, Prop, Vue } from "vue-property-decorator";
import { omit } from "lodash";

@Component({ components: {} })
export default class DoKoSvgImgMixin extends Vue {
  readonly imgList!: string;
  @Prop({
    type: Boolean,
    default: false,
  })
  svg!: boolean;

  @Prop({
    type: String,
    required: true,
  })
  imgId!: string;

  @Prop({
    type: Number,
    default: null,
  })
  x!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  y!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  h!: null | number;

  @Prop({
    type: Number,
    default: null,
  })
  w!: null | number;

  get tagName() {
    return this.svg ? "image" : "img";
  }
  get urlAttrName() {
    return this.svg ? "href" : "src";
  }

  get imgUrl() {
    const imgList = this.imgList;
    return `/img/${imgList}s.svg#${imgList}-${this.imgId}`;
  }

  get style() {
    const style: any = {};
    if (this.h !== null) {
      style.height = `${this.h ?? 50}px`;
    }
    if (this.w !== null) {
      style.width = `${this.w ?? 50}px`;
    }
    if (this.x !== null) {
      style.position = "absolute";
      style.left = `${this.x ?? 0}px`;
    }
    if (this.y !== null) {
      style.position = "absolute";
      style.top = `${this.y ?? 0}px`;
    }
    return style;
  }

  get svgAttrs() {
    const attrs: any = {
      x: this.x,
      y: this.y,
    };
    if (this.h !== null) {
      attrs.height = `${this.h ?? 50}`;
    }
    if (this.w !== null) {
      attrs.width = `${this.w ?? 50}`;
    }
    return attrs;
  }

  get htmlAttrs() {
    const attrs: any = {
      style: this.style,
    };
    return attrs;
  }

  get cleanAttrs() {
    return omit(this.$attrs, ["height", "width", "x", "y", "src", "href"]);
  }

  get tagAttrs() {
    return {
      ...this.cleanAttrs,
      [this.urlAttrName]: this.imgUrl,
      ...(this.svg ? this.svgAttrs : this.htmlAttrs),
    };
  }
}
